module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Star_16"],"polygon":[{"$":{"points":"8 1 9.9 5.33 15 5.33 10.8 8.89 13 14.25 8 11.23 3 14.31 5.2 8.9 1 5.33 6.1 5.33 8 1","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Star_16.svg
// module id = TS3r
// module chunks = 1